// active function

$(document).ready(function () {
  if ($(".wish-count").text() == 0) {
    $(".count_wish").hide();
  } else {
    $(".count_wish").show();
  }
  $(document).on("click", ".whis", function () {
    if ($(this).hasClass("active")) {
      $(".wish-count").html(parseInt($(".wish-count").html()) - 1);
    } else {
      $(".wish-count").html(parseInt($(".wish-count").html()) + 1);
    }
    if ($(".wish-count").text() == 0) {
      $(".count_wish").hide();
    } else {
      $(".count_wish").show();
    }
    $(this).toggleClass("active");
  });
});

// empty wishlist

var filmArray = JSON.parse(localStorage.getItem("pools") || "[]");
var filmArray1 = JSON.parse(localStorage.getItem("poolsid") || "[]");
var count_wish = filmArray.length;
var count_wish1 = filmArray1.length;
console.log(count_wish);
setTimeout(function(){$("body .count_wish ").append('<span class="wish-count">' + count_wish + "</span>");},800);
console.log('cout',count_wish);

// handle function

function wishlist_toggle(variant_id, handle) {
  var wish_pros = localStorage.pools;
  var wish_id = localStorage.poolsid;

  if (wish_pros == null) {
    wish_pros = [];
    wish_id = [];
  } else {
    wish_pros = JSON.parse(wish_pros);
    wish_id = JSON.parse(wish_id);
  }
  var index = wish_pros.indexOf(handle);
  var index1 = wish_id.indexOf(variant_id);
  if (index > -1) {
    wish_pros.splice(index, 1);
    wish_id.splice(index1, 1);
  } else {
    wish_pros.push(handle);
    wish_id.push(variant_id);
  }
  localStorage.pools = JSON.stringify(wish_pros);
  localStorage.poolsid = JSON.stringify(wish_id);
}

$(document).ready(function () {
  var wish = JSON.parse(localStorage.getItem("pools"));
  var wishid = JSON.parse(localStorage.getItem("poolsid"));

  var res = [];
  for (var i in wish) {
    console.log($('[pro_handle="' + wish[i] + '"]'));
    console.log("wish", wish[i]);
    console.log("wishid", wishid[i]);

    $('[pro_handle="' + wish[i] + '"]').addClass("active");
  }
});

$(document).ready(function () {
  var wish = JSON.parse(localStorage.getItem("pools"));
  var wishid = JSON.parse(localStorage.getItem("poolsid"));

  var res = [];
  for (var i in wish) {
    console.log(wish[i]);
    jQuery.ajax({
      type: "GET",
      async: false,
      url: "/products/" + wish[i] + ".json",
      dataType: "json",
      success: function (response) {
        console.log(response);
        $(".slider-for-desk_wish").append(
          `<div class="mobile_dexk">
                     
                        <div class="collection-of-products">
                          <div class="collection-content" data="` +
            response.product.variants[0].id +
            `">
 <div class="whis active" id="whislist" pro_handle="/products/` +
            wish[i] +
            `" onclick="wishlist_toggle('` +
            response.product.variants[0].id +
            `', '` +
            response.product.handle +
            `')">
                                  <style>
                                     .whis {
                                        border: none;
                                        background: transparent;cursor:pointer;
                                    }
                                  </style><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36.001 31.501">
                <path id="Icon_awesome-heart" data-name="Icon awesome-heart" d="M32.505,4.4a9.615,9.615,0,0,0-13.12.956L18,6.785,16.615,5.358A9.615,9.615,0,0,0,3.495,4.4,10.1,10.1,0,0,0,2.8,19.02L16.4,33.068a2.2,2.2,0,0,0,3.185,0L33.195,19.02A10.09,10.09,0,0,0,32.505,4.4Z" transform="translate(0.001 -2.248)" fill="#dadada"></path>
              </svg>
              </div>
                             <a href="/products/` +
            wish[i] +
            `" tabindex="0">    
                            <div class="backgorund_products">
                              <div class="products-img">
                                <img src="` +
            response.product.image.src +
            `">

 <div class="whislist_product tst lsp_options">
                                <button id="Collection_addtocard" newid="` +
            wishid[i] +
            `" data-prod-title="`+
            response.product.title + `" class="product_size">
                                  <span class="quick-view-open" data-product-url="/products/` +
            wish[i] +
            `">QUICK ADD TO BAG</span>
                                </button>
                              </div>
                              </div>
                             
                            </div></a>

                          
                            <div class="star_img" style="display: none">
                              <svg xmlns="http://www.w3.org/2000/svg" width="137.5" height="21.25" viewBox="0 0 137.5 21.25">
                                <path id="Union_12" data-name="Union 12" d="M132.2,21.066l-5.9-4.3-5.9,4.3a.966.966,0,0,1-.5.184.764.764,0,0,1-.45-.2.831.831,0,0,1-.275-.919l2.318-6.891-6.04-4.352a.791.791,0,0,1-.335-.577.641.641,0,0,1-.015-.138.811.811,0,0,1,.8-.817h7.4L125.548.541a.8.8,0,0,1,1.52,0L129.3,7.356h7.35a.855.855,0,0,1,.849.817.866.866,0,0,1-.26.547l-.145.127L131.1,13.24l2.318,6.891a.819.819,0,0,1-.275.919.708.708,0,0,1-.444.2A.922.922,0,0,1,132.2,21.066Zm-28.779,0-5.9-4.3-5.9,4.3a.966.966,0,0,1-.5.184.764.764,0,0,1-.45-.2.83.83,0,0,1-.275-.919l2.318-6.891-6.04-4.352a.791.791,0,0,1-.335-.577.641.641,0,0,1-.015-.138.811.811,0,0,1,.8-.817h7.4L96.769.541a.8.8,0,0,1,1.52,0l2.233,6.814h7.35a.855.855,0,0,1,.849.817.866.866,0,0,1-.26.547l-.145.127-5.991,4.393,2.318,6.891a.819.819,0,0,1-.275.919.708.708,0,0,1-.444.2A.922.922,0,0,1,103.425,21.066Zm-28.779,0-5.9-4.3-5.9,4.3a.968.968,0,0,1-.5.184.764.764,0,0,1-.45-.2.83.83,0,0,1-.275-.919l2.318-6.891-6.04-4.352a.791.791,0,0,1-.335-.577.642.642,0,0,1-.015-.138.811.811,0,0,1,.8-.817h7.4L67.99.541a.8.8,0,0,1,1.519,0l2.234,6.814h7.35a.855.855,0,0,1,.849.817.866.866,0,0,1-.26.547l-.145.127L73.547,13.24l2.318,6.891a.819.819,0,0,1-.275.919.708.708,0,0,1-.444.2A.922.922,0,0,1,74.646,21.066Zm-28.779,0-5.9-4.3-5.9,4.3a.968.968,0,0,1-.5.184.764.764,0,0,1-.45-.2.83.83,0,0,1-.275-.919l2.318-6.891-6.04-4.352a.791.791,0,0,1-.335-.577.642.642,0,0,1-.015-.138.811.811,0,0,1,.8-.817h7.4L39.212.541a.8.8,0,0,1,1.518,0l2.234,6.814h7.35a.855.855,0,0,1,.849.817.866.866,0,0,1-.26.547l-.145.127L44.767,13.24l2.318,6.891a.819.819,0,0,1-.275.919.708.708,0,0,1-.444.2A.922.922,0,0,1,45.867,21.066Zm-28.779,0-5.9-4.3-5.9,4.3a.966.966,0,0,1-.5.184.764.764,0,0,1-.45-.2.83.83,0,0,1-.275-.919L6.39,13.24.35,8.888a.791.791,0,0,1-.335-.577A.642.642,0,0,1,0,8.173a.811.811,0,0,1,.8-.817H8.2L10.432.541a.8.8,0,0,1,1.519,0l2.234,6.814h7.35a.855.855,0,0,1,.849.817.866.866,0,0,1-.26.547l-.145.127L15.988,13.24l2.318,6.891a.819.819,0,0,1-.275.919.708.708,0,0,1-.444.2A.922.922,0,0,1,17.088,21.066Z" fill="#ebb12d"></path>
                              </svg>
                            </div>
                            <div class="products_content">
                              
                              <h4 class="product-title">` +
            response.product.title + 
            `</h4>
                              <span class="price_products">` +
            response.product.variants[0].price +
            `</span><br>
                               
           
                            </div>
                          </div>
                        </div>
                    </div>`
        );
      },
    });
  }

});

var ids1 = $(".template-product variant-radios label")
  .parents(".product__info-wrapper")
  .find(".product-variant-id")
  .attr("value");
var pro_handle1 = $(".template-product variant-radios label")
  .parents(".product__info-wrapper")
  .find(".whis")
  .attr("pro_handle");
var pro1 = $(".template-product variant-radios label")
  .parents(".product__info-wrapper")
  .find(".whis")
  .attr("onclick", 'wishlist_toggle("' + ids1 + '", "' + pro_handle1 + '")');
$(".template-product variant-radios label").click(function () {
  var this1 = $(this);
  setTimeout(function () {
    var ids = this1
      .parents(".product__info-wrapper")
      .find(".product-variant-id")
      .attr("value");
    var pro_handle = this1
      .parents(".product__info-wrapper")
      .find(".whis")
      .attr("pro_handle");
    var pro = this1
      .parents(".product__info-wrapper")
      .find(".whis")
      .attr("onclick", 'wishlist_toggle("' + ids + '", "' + pro_handle + '")');
  }, 100);
});

$(document).on("click", ".template--wishlist .whis.active", function () {
  window.location.reload();
});

$(document).on(
  "click",
  ".template-product button.add_cart_product",
  function (event) {
    console.log("i am clicked fghfgh");
    $(".drawer").removeClass("is-empty");
    var cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    event.preventDefault();
    var arr = [];
    var id1 = $(".product-variant-id").val();
    arr.push({ id: id1, quantity: 1 });
    var id2 = $(".another_id").first().text();
    arr.push({ id: id2, quantity: 1 });
    console.log(arr);
    $.ajax({
      type: "GET",
      url: "/cart/add.js",
      data: {
        items: arr,
        sections: cart.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname,
      },
      dataType: "json",
      success: function (response) {
        cart.renderContents(response);
      },
      error: function () {
        console.log("error");
      },
    });
  }
);

var values1 = $(
  '.template-product:has(.variants_free) fieldset[option="Size"] input:checked'
).val();
var ids_variants1 = $(
  '.template-product:has(.variants_free) fieldset[option="Size"] label'
)
  .parents(".product__info-wrapper")
  .find('.variants_free span[data-title="' + values1 + '"]').first()
  .text();
$('.template-product:has(.variants_free) fieldset[option="Size"] label')
  .parents(".product__info-wrapper")
  .find(".another_id")
  .text(ids_variants1);

$(document).on(
  "click",
  '.template-product:has(.variants_free) fieldset[option="Size"] label',
  function () {
    var options = $(this).attr("for");
    var values = $(this)
      .parents('fieldset[option="Size"]')
      .find('input[id="' + options + '"]')
      .val();
    console.log('values',values);
    var ids_variants = $(this)
      .parents(".product__info-wrapper")
      .find('.variants_free span[data-title="' + values + '"]').first()
      .text();
    console.log('ids_variants',ids_variants);
    $(this)
      .parents(".product__info-wrapper")
      .find(".another_id")
      .text(ids_variants);
  }
);


$(document).on('click', '.template--wishlist .whislist_product button#Collection_addtocard', function (event) {
console.log("i am clicked")
$('.drawer').removeClass('is-empty');
var cart =
document.querySelector("cart-notification") ||
document.querySelector("cart-drawer");
event.preventDefault();
var arr = [];
    var title=$(this).attr('data-prod-title');
    var id1 = ($(this).attr('newid'));
    var id01= $('.variants_free_wishlist_prod span[data-varid="'+id1+'"]').attr('data-title');
    var id001=$('.variants_free_wishlist_prod span[data-varid="'+id1+'"]').parents('.variants_free_wishlist_prod').attr('data-product-title');
    if(title==id001){ 
     arr.push({ id: id1, quantity: 1 });    
    //var id02= $('.variants_free_wishlist[data-product-title="'+id001+'"] span[data-title="'+id01+'"]').text();
    var id2 = $('.another_id_wishlist[data-products-title="'+id001+'"]').text();
    arr.push({ id: id2, quantity: 1 });
    console.log('ids',id2);
    $.ajax({
      type: "GET",
      url: "/cart/add.js",
      data: {
        items: arr,
        sections: cart.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname,
      },
      dataType: "json",
      success: function (response) {
        cart.renderContents(response);
      },
      error: function () {
        console.log("error");
      },
    });
}
else{
    //var  id = ($(this).attr('newid'));
console.log(id1,"id")
arr.push({id:id1,quantity:1,})
  console.log(arr);
     $.ajax({
          type: 'GET',
          url: '/cart/add.js',
          data:{items:arr,sections: cart.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname,},
          dataType: 'json',
          success: function (response) {
           cart.renderContents(response);
           },
          error: function () {
              console.log('error');
          }
      });
}
});


$(document).ready(function(){
   $(document).on('click','.product-popup-modal__button',function(){
       var a = $(this).parent().attr('data-modal');
       console.log(a);
       $(a).find('.tablinks').eq(0).trigger('click'); 
       
   });
});